import {SxProps, TextField} from '@mui/material';
import {DatePicker} from '@mui/x-date-pickers';
import {Dayjs} from 'dayjs';
import {FC, memo} from 'react';
import {Controller, Message, ValidationRule, useFormContext} from 'react-hook-form';

interface PropsFromParent {
  name: string;
  label?: string;
  disabled?: boolean;
  multiline?: boolean;
  maxRows?: number;
  borderColor?: string;
  validators?: Partial<{
    required: Message | ValidationRule<boolean>;
    min: ValidationRule<number | string>;
    max: ValidationRule<number | string>;
    maxLength: ValidationRule<number>;
    minLength: ValidationRule<number>;
    pattern: ValidationRule<RegExp>;
    valueAsNumber: boolean;
    valueAsDate: boolean;
    setValueAs: (value: any) => any;
    shouldUnregister?: boolean;
    onChange?: (event: any) => void;
    onBlur?: (event: any) => void;
    disabled: boolean;
  }>;
  sx?: SxProps;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  autoFocus?: boolean;
  autoOpen?: boolean;
  onChange?(value: any): void;
  onClose?(): void;
  defaultValue?: Dayjs;
}

export const DateInput: FC<PropsFromParent> = memo((props) => {
  const {
    control,
    formState: {errors},
  } = useFormContext();
  const helperTextFromPropsNameMessage = errors[props.name]?.message as string;

  return (
    <Controller
      name={props.name}
      control={control}
      rules={props.validators}
      defaultValue={props.defaultValue}
      render={({field}) => (
        <DatePicker
          {...field}
          disabled={props.disabled}
          label={props.label}
          minDate={props.minDate}
          maxDate={props.maxDate}
          autoFocus={props.autoFocus}
          open={props.autoOpen}
          onClose={props.onClose}
          onChange={(value) => {
            field.onChange(value);
            props.onChange && props.onChange(value);
          }}
          inputFormat='DD/MM/YYYY'
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              sx={{...props.sx, marginTop: 1, marginBottom: 2}}
              error={!!errors[props.name]}
              helperText={helperTextFromPropsNameMessage}
            />
          )}
        />
      )}
    />
  );
});
